export default __webpack_public_path__ + "static/media/ca-app-icon.f4d1847c.svg";